import React, { useState, useEffect } from 'react';
import CustomTable from '../../../../customComponents/CustomTable';
import downloadIcon from './../../../../../Assets/icons/download.svg';
import './index.scss';
import { useNavigate } from 'react-router-dom';
import axiosInstance from '../../../../services/api/API';
import ROUTES_NAVIGATION from '../../../../../routes/routes';
import { TABLE_HEADERS, keyMapping } from '../../../../../constants/VendorList';
import { toastSuccess } from '../../../../customComponents/customToast/Toast';
import { ToastContainer } from 'react-toastify';
import searchIcon from "../../../../../Assets/icons/searchicon.svg";
import SearchInput from '../../../../customComponents/CustomSearch/SearchInput';
import Loader from '../../../../customComponents/CustomLoader';

const VendorList = () => {
  const [tableData, setTableData] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');
  const [totalRecords, setTotalRecords] = useState(0);
  const [currentPage, setCurrentPage] = useState(0);
  const [totalPages, setTotalPages] = useState(0);
  const [loading, setLoading] = useState(true);
  const [ totalData, setTotalData ] = useState(0)
  const [totalActive, setTotalActive] = useState(0)
  const [ totalInactive, setTotalInactive ] = useState(0)

  const navigate = useNavigate();
  const token = localStorage.getItem('authToken');

  // useEffect(() => {
  //   fetchVendorData();
  // }, []);

  const fetchVendorData = async (page = 0, pageSize = 10) => {
    try {
      setLoading(true)
      const response = await axiosInstance.post(
        '/vendor/list',
        {
          orderBy: 'vendor_onboard_id desc',
          page,
          pageSize,
          searchText:searchTerm
        },
        {
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`,
          },
        }
      );

      const formattedData = response?.data?.data?.data?.map((item, index) => ({
        ...item,
        'Sr No.': index + 1,
      }));

      const totalRecordsData = response?.data?.data?.totalRecords
      console.log(totalRecordsData, "RECORDS")
      setTotalRecords(totalRecordsData);

      const totalCount = response?.data?.data?.total
      const totalAct = response?.data?.data?.total_active
      const totalInac = response?.data?.data?.total_inactive

      setTotalData(totalCount)
      setTotalActive(totalAct)
      setTotalInactive(totalInac)

      console.log('response', response);
      setTableData(formattedData);
     // toastSuccess("Product Data fetched successfully!");
      setTotalPages(Math.ceil(response?.data?.data?.totalRecords / pageSize));
    } catch (error) {
      console.error('Error fetching vendor list:', error);
    }
    finally{
      setLoading(false)
    }
  };



  const handleEditButton = (rowData) => {
    console.log("rowdata>", rowData);
    navigate(`${ROUTES_NAVIGATION.VENDOREDIT}`, { state: { data: rowData } });
    console.log("rowdata", rowData)
  }

  const handlePageChange = (newPage) => {
    setCurrentPage(newPage);
    fetchVendorData(newPage);
  };
  useEffect(() => {
    if (searchTerm === "") {
      fetchVendorData();
    }
  }, [searchTerm]);

  return (
    <div>
    {loading ? ( 
      <Loader />
    ) : (
    <div>
      <div className='vendorContainer'>
        <div className=''>
          <h5>Vendor List</h5>
        </div>
        <div className='totalvaluescontainer col-xl-6 col-lg-12 mt-2 mb-2'>
        <div className='topleftdataContainer' style={{borderRight: "1px solid lightgrey"}} >
            <h5 className="listTopDataValueText"  >{totalData} </h5>
            <h6>All Data</h6>
          </div>
          <div className='topleftdataContainer' style={{borderRight: "1px solid lightgrey"}} >
            <h5 className="listTopDataValueText"  >{totalActive} </h5>
            <h6>Active Data</h6>
          </div>
          <div className='topleftdataContainer'>
            <h5 className="listTopDataValueText"  >{totalInactive} </h5>
            <h6>Inactive Data</h6>
          </div>
          <button
            className='addcustomerbutton'
            onClick={() => navigate(ROUTES_NAVIGATION.VENDORADD)}
          >
            Add Vendor
          </button>
        </div>
      </div>

      <div className='tableWrapper'>
        <div className='admin-list-container'>
        <div className='listsearchContainer'>
          <h5>Vendor List</h5>
          <div>
              <SearchInput
                placeholder="Search Vendor"
                onSearch={fetchVendorData}
                searchTerm={searchTerm}
                setSearchTerm={setSearchTerm}
              />
            </div>
          </div>
        
        </div>

        <CustomTable
          data={tableData}
          headers={TABLE_HEADERS}
          keyMapping={keyMapping}
          itemsPerPage={10}
          onEdit={handleEditButton}
          totalPages={totalPages}
          totalRecords={totalRecords} 
          currentPage={currentPage}
          onPageChange={handlePageChange}
          
        />
      </div>
    </div>
    )}
    </div>
  );
};

export default VendorList;
